<template>
  <b-modal
    v-model="visible"
    class="my-modal"
    modal-class="attachment-lightbox"
    backdrop-class="attachment-lightbox-backdrop"
    dialog-class="attachment-lightbox-dialog"
    body-class="attachment-lightbox-body"
    hide-header
    hide-footer
    centered
    size="xl"
  >
    <div class="attachment-lightbox-wrapper" @click.self="visible = false">
      <button
        type="button"
        class="attachment-lightbox-close"
        aria-label="Fechar"
        @click="visible = false"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <img :src="src" :alt="name" class="attachment-lightbox-img" />
    </div>
    <div class="attachment-lightbox-caption">
      <span v-text="name"></span>
      <a
        :href="src"
        :download="name"
        target="_blank"
        rel="noopener noreferrer"
        class="attachment-lightbox-download"
        aria-label="Download"
      >
        <svg width="16" height="16">
          <image
            xlink:href="../../../src/assets/icons/download.svg"
            width="16"
            height="16"
          />
        </svg>
      </a>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "AttachmentLightbox",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      default: "",
    },
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
};
</script>

<style scoped>
.attachment-lightbox-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  min-height: 200px;
}
.attachment-lightbox-img {
  max-width: 100%;
  max-height: 76vh;
  object-fit: contain;
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.08);
}
.attachment-lightbox-close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #e2e8f0;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.12);
  color: #64748b;
  font-size: 1.25rem;
  line-height: 1;
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
}
.attachment-lightbox-close:hover {
  color: #730ca8;
  border-color: #730ca8;
}
.attachment-lightbox-caption {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid #e2e8f0;
  background-color: #fff;
  color: #64748b;
  font-size: 12px;
  text-align: center;
  word-break: break-all;
}
.attachment-lightbox-download {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
}
</style>

<style lang="scss">
.attachment-lightbox {
  .modal-content {
    border: none;
    border-radius: 12px;
    overflow: hidden;
    background-color: #f8fafc;
    box-shadow: 0 16px 48px rgba(15, 23, 42, 0.24);
  }
  .modal-body {
    padding: 0;
    background-color: #f8fafc;
  }
  .attachment-lightbox-dialog {
    max-width: min(1080px, 94vw);
  }
}
.attachment-lightbox-backdrop.modal-backdrop.show {
  background-color: rgba(15, 23, 42, 0.55);
  opacity: 1;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
</style>
